// Shared by the browser and build-time renderer; only describes visible content.
const ORIGIN = 'https://www.fieldlink.co.nz';
function civilClusterSchema(page) {
  return [
    {
      '@context': 'https://schema.org', '@type': 'WebPage',
      '@id': `${ORIGIN}${page.path}#webpage`, url: `${ORIGIN}${page.path}`,
      name: page.title, description: page.description, inLanguage: 'en-NZ',
      isPartOf: { '@type': 'WebSite', name: 'Fieldlink NZ', url: `${ORIGIN}/` },
      about: { '@type': 'SoftwareApplication', '@id': `${ORIGIN}/#software`, name: 'Fieldlink NZ', applicationCategory: 'BusinessApplication', operatingSystem: 'Web (PWA)', url: `${ORIGIN}/` },
    },
    {
      '@context': 'https://schema.org', '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Fieldlink NZ', item: `${ORIGIN}/` },
        { '@type': 'ListItem', position: 2, name: page.parent?.label || 'Job management', item: `${ORIGIN}${page.parent?.to || '/job-management-nz'}` },
        { '@type': 'ListItem', position: 3, name: page.label, item: `${ORIGIN}${page.path}` },
      ],
    },
  ];
}
module.exports = { civilClusterSchema };
